export default __webpack_public_path__ + "static/i-MedicalCard Elite_e-Flyer-59bd44d635e9a2d9098bfd33f495ea64.pdf";